// extracted by mini-css-extract-plugin
export default {"container":"wc0qr9VOS2e24JtJOGQN","row":"IOXpQzHhy2agpijKfpwb"};